module.exports = {"360725100":"横水镇","360725101":"扬眉镇","360725102":"过埠镇","360725103":"铅厂镇","360725104":"长龙镇","360725105":"关田镇","360725200":"龙勾乡","360725201":"杰坝乡","360725202":"金坑乡","360725203":"思顺乡","360725204":"麟潭乡","360725205":"上堡乡","360725206":"聂都乡","360725207":"文英乡","360725208":"乐洞乡","360725209":"丰州乡","360725500":"天台山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360725.json
// module id = 1192
// module chunks = 0